export enum ICONS {
  ACCOUNT_CIRCLE_OUTLINE = 'mdi:account-circle-outline',
  ACCOUNT_OUTLINE = 'mdi:account-outline',
  ADD = 'mdi:plus',
  AKAR_ICONS_CHEVRON_UP = 'akar-icons:chevron-up',
  AKAR_ICONS_WATER = 'akar-icons:water',
  ALERT = 'mdi:alert',
  ALERT_CIRCLE = 'mdi:alert-circle',
  ANT_DESIGN_FILE_EXCEL_OUTLINED = 'ant-design:file-excel-outlined',
  ANT_DESIGN_FILE_PDF_OUTLINED = 'ant-design:file-pdf-outlined',
  ANT_DESIGN_STOP_OUTLINED = 'ant-design:stop-outlined',
  APPROXIMATED = 'mdi:chart-timeline-variant-shimmer',
  APPROXIMATION = 'mdi:chart-timeline-variant-shimmer',
  AREA = 'mdi:surface-area',
  AREA2 = 'mdi:texture-box',
  ARROW_DOWN = 'mdi:arrow-down',
  ARROW_RIGHT = 'mdi:arrow-right',
  ARROW_UP = 'mdi:arrow-up',
  BAROMETER = 'mdi:barometer',
  BI_CHECK = 'bi:check',
  BI_CLOUD_HAIL = 'bi:cloud-hail',
  BI_CLOUD_RAIN_HEAVY = 'bi:cloud-rain-heavy',
  BI_CLOUD_SNOW = 'bi:cloud-snow',
  BI_LAYERS_HALF = 'bi:layers-half',
  BI_THERMOMETER_SUN = 'bi:thermometer-sun',
  BUILDING = 'mdi:home-city-outline',
  BX_ADD_TO_QUEUE = 'bx:add-to-queue',
  CALCULATOR = 'mdi:calculator',
  CALENDAR = 'mdi:calendar',
  CANCEL = 'mdi:cancel',
  CARBON_CALENDAR = 'carbon:calendar',
  CARBON_CHECKMARK_OUTLINE = 'carbon:checkmark-outline',
  CARBON_ERROR_OUTLINE = 'carbon:error-outline',
  CARBON_LIGHTNING = 'carbon:lightning',
  CARBON_LOCKED = 'carbon:locked',
  CHARM_CROSS = 'charm:cross',
  CHART_BAR = 'mdi:chart-bar',
  CHART_TIMELINE = 'mdi:chart-timeline',
  CHECK = 'mdi:check',
  CHECK_CIRCLE = 'mdi:check-circle',
  CHECK_OUTLINE = 'mdi:clipboard-check-outline',
  CHEVRON_DOWN = 'mdi:chevron-down',
  CHEVRON_LEFT = 'mdi:chevron-left',
  CHEVRON_RIGHT = 'mdi:chevron-right',
  CHEVRON_UP = 'mdi:chevron-up',
  CIRCLE_HALF_FULL = 'mdi:circle-half-full',
  CIRCLE_OUTLINE = 'mdi:circle-outline',
  CIRCLE_SLICE_8 = 'mdi:circle-slice-8',
  CIL_WINDOW = 'cil:window',
  CI_EXTERNAL_LINK = 'ci:external-link',
  CLARITY_UPLOAD_CLOUD_LINE = 'clarity:upload-cloud-line',
  CLOCK = 'mdi:clock',
  CLOSE = 'mdi:close',
  CLOSE_CIRCLE = 'mdi:close-circle',
  CLIPBOARD_PULSE_OUTLINE = 'mdi:clipboard-pulse-outline',
  HOME_VARIANT_OUTLINE = 'mdi:home-variant-outline',
  COG = 'mdi:cog-outline',
  COMMERCIAL_BUILDING = 'mdi:office-building',
  CONSTRUCTION_YEAR = 'mdi:crane',
  COST_VERSION = 'mdi:calculator',
  COUNTRY = 'mdi:flag',
  DANGER = 'mdi:alert-circle',
  DASHBOARD_VIEW = 'mdi:chart-bar',
  DOMAIN = 'mdi:domain',
  DATABASE_OUTLINE = 'mdi:database-outline',
  DRAG = 'mdi:drag',
  EDIT = 'mdi:square-edit-outline',
  EDIT_SQUARE = 'mdi:square-edit-outline',
  ELECTRICITY = 'mdi:electricity-outline',
  ENERGY = 'mdi:energy-circle',
  ENTYPO_SOUND_MIX = 'entypo:sound-mix',
  EURO = 'mdi:currency-eur',
  EVA_ACTIVITY_OUTLINE = 'eva:activity-outline',
  EVA_ALERT_CIRCLE_FILL = 'eva:alert-circle-fill',
  EVA_ALERT_TRIANGLE_FILL = 'eva:alert-triangle-fill',
  EVA_ARROW_IOS_DOWNWARD_FILL = 'eva:arrow-ios-downward-fill',
  EVA_ARROW_IOS_FORWARD_FILL = 'eva:arrow-ios-forward-fill',
  EVA_CHECKMARK_CIRCLE_2_FILL = 'eva:checkmark-circle-2-fill',
  EVA_CHECKMARK_CIRCLE_2_OUTLINE = 'eva:checkmark-circle-2-outline',
  EVA_CHEVRON_DOWN_FILL = 'eva:chevron-down-fill',
  EVA_CLOCK_FILL = 'eva:clock-fill',
  EVA_CLOSE_FILL = 'eva:close-fill',
  EVA_CLOUD_DOWNLOAD_OUTLINE = 'eva:cloud-download-outline',
  EVA_COFFEE_FILL = 'eva:coffee-fill',
  EVA_DONE_ALL_FILL = 'eva:done-all-fill',
  EVA_EDIT_FILL = 'eva:edit-fill',
  EVA_FILE_TEXT_OUTLINE = 'eva:file-text-outline',
  EVA_INFO_FILL = 'eva:info-fill',
  EVA_MENU_2_FILL = 'eva:menu-2-fill',
  EVA_MORE_VERTICAL_FILL = 'eva:more-vertical-fill',
  EVA_PLUS_FILL = 'eva:plus-fill',
  EVA_SEARCH_FILL = 'eva:search-fill',
  EVA_SETTINGS_2_FILL = 'eva:settings-2-fill',
  EVA_SETTINGS_2_OUTLINE = 'eva:settings-2-outline',
  EVA_TRENDING_DOWN_FILL = 'eva:trending-down-fill',
  EVA_TRENDING_UP_FILL = 'eva:trending-up-fill',
  EXPORT = 'mdi:file-download-outline',
  EXTERNAL_LINK = 'mdi:external-link',
  FA_REGULAR_EDIT = 'fa-regular:edit',
  FA_SOLID_FILE_UPLOAD = 'fa-solid:file-upload',
  FILE_COMPARE = 'mdi:file-compare',
  FILE_DOCUMENT_CHECK = 'mdi:file-document-check',
  FILE_MULTIPLE_OUTLINE = 'mdi:file-multiple-outline',
  FILE_UPLOAD = 'mdi:file-upload',
  FILE_UPLOAD_OUTLINE = 'mdi:file-upload-outline',
  FOLDER_MOVE = 'mdi:folder-move',
  FOLDER_OUTLINE = 'mdi:folder-outline',
  FLUENT_DOCUMENT_TABLE_SEARCH_20_REGULAR = 'fluent:document-table-search-20-regular',
  FLUENT_SETTINGS_32_REGULAR = 'fluent:settings-32-regular',
  FORMKIT_ARROWRIGHT = 'formkit:arrowright',
  GAUGE = 'mdi:gauge',
  GIS_LAYER = 'gis:layer',
  GLOBE = 'mdi:globe',
  GRIDICONS_CREATE = 'gridicons:create',
  HEAT = 'material-symbols:heat',
  HELP_CIRCLE = 'mdi:help-circle-outline',
  HEROICONS_OUTLINE_LIGHTNING_BOLT = 'heroicons-outline:lightning-bolt',
  HIDE = 'mdi:eye-off',
  HOME = 'mdi:home-variant-outline',
  HOME_REMOVE_OUTLINE = 'mdi:home-remove-outline',
  ICON_PARK_OUTLINE_RETURN = 'icon-park-outline:return',
  IC_BASELINE_EDIT = 'ic:baseline-edit',
  IC_BASELINE_FILE_DOWNLOAD = 'ic:baseline-file-download',
  IC_OUTLINE_ARROW_FORWARD_IOS = 'ic:outline-arrow-forward-ios',
  IC_OUTLINE_EMAIL = 'ic:outline-email',
  IC_OUTLINE_PERCENTAGE = 'ic:outline-percentage',
  IC_ROUND_FILTER_LIST = 'ic:round-filter-list',
  INFO = 'mdi:information-outline',
  INFO_CONTAINED = 'mdi:information',
  INSULATION_THICKNESS = 'mdi:arrow-expand-horizontal',
  ION_WARNING = 'ion:warning',
  KEYBOARD_ARROW_DOWN = 'mdi:keyboard-arrow-down',
  LA_FIRE_ALT = 'la:fire-alt',
  LABEL_OUTLINE = 'mdi:label-outline',
  LAYERS_OUTLINE = 'mdi:layers-outline',
  LEAVE = 'pepicons-pop:leave',
  LINK_VARIANT = 'mdi:link-variant',
  LIST_VIEW = 'mdi:format-list-bulleted-square',
  LUCIDE_EDIT = 'lucide:edit',
  MATERIAL_SYMBOLS_ADD_BOX_OUTLINE = 'material-symbols:add-box-outline',
  MATERIAL_SYMBOLS_ARROW_BACK_IOS = 'material-symbols:arrow-back-ios',
  MATERIAL_SYMBOLS_ARROW_BACK_IOS_NEW_ROUNDED = 'material-symbols:arrow-back-ios-new-rounded',
  MATERIAL_SYMBOLS_ARROW_DROP_DOWN_ROUNDED = 'material-symbols:arrow-drop-down-rounded',
  MATERIAL_SYMBOLS_ARROW_DROP_UP_ROUNDED = 'material-symbols:arrow-drop-up-rounded',
  MATERIAL_SYMBOLS_ARROW_FORWARD_IOS = 'material-symbols:arrow-forward-ios',
  MATERIAL_SYMBOLS_ARROW_FORWARD_IOS_ROUNDED = 'material-symbols:arrow-forward-ios-rounded',
  MATERIAL_SYMBOLS_ARROW_OUTWARD = 'material-symbols:arrow-outward',
  MATERIAL_SYMBOLS_CHEVRON_LEFT = 'material-symbols:chevron-left',
  MATERIAL_SYMBOLS_CLOSE = 'material-symbols:close',
  MATERIAL_SYMBOLS_EDIT_SHARP = 'material-symbols:edit-sharp',
  MATERIAL_SYMBOLS_ERROR_ROUNDED = 'material-symbols:error-rounded',
  MATERIAL_SYMBOLS_FILE_OPEN_OUTLINE_ROUNDED = 'material-symbols:file-open-outline-rounded',
  MATERIAL_SYMBOLS_FOLDER_MANAGED_OUTLINE_ROUNDED = 'material-symbols:folder-managed-outline-rounded',
  MATERIAL_SYMBOLS_INFO_OUTLINE = 'material-symbols:info-outline',
  MATERIAL_SYMBOLS_LINK = 'material-symbols:link',
  MATERIAL_SYMBOLS_LOCK_OPEN_ROUNDED = 'material-symbols:lock-open-rounded',
  MATERIAL_SYMBOLS_MAIL_OUTLINE = 'material-symbols:mail-outline',
  MATERIAL_SYMBOLS_OPEN_IN_NEW = 'material-symbols:open-in-new',
  MATERIAL_SYMBOLS_TUNE = 'material-symbols:tune',
  MATERIAL_SYMBOLS_UNDO = 'material-symbols:undo',
  MATERIAL_SYMBOLS_VIEW_COLUMN = 'material-symbols:view-column',
  MDI_ACCOUNT_GROUP_OUTLINE = 'mdi:account-group-outline',
  MDI_ARROW_RIGHT_THICK = 'mdi:arrow-right-thick',
  MDI_BELL_OUTLINE = 'mdi:bell-outline',
  MDI_CHART_BAR_STACKED = 'mdi:chart-bar-stacked',
  MDI_CONTENT_COPY = 'mdi:content-copy',
  MDI_DELETE = 'mdi:delete',
  MDI_DOOR = 'mdi:door',
  MDI_DOWNLOAD = 'mdi:download',
  MDI_FILE_OUTLINE = 'mdi:file-outline',
  MDI_HELP_CIRCLE = 'mdi:help-circle',
  MDI_HOME_ROOF = 'mdi:home-roof',
  MDI_LOGOUT = 'mdi:logout',
  MDI_PAPERCLIP = 'mdi:paperclip',
  MDI_PENCIL = 'mdi:pencil',
  MDI_PERCENT_OUTLINE = 'mdi:percent-outline',
  MDI_QUESTION_MARK_CIRCLE_OUTLINE = 'mdi:question-mark-circle-outline',
  MDI_RELOAD = 'mdi:reload',
  MDI_SPEEDOMETER = 'mdi:speedometer',
  MDI_STAR = 'mdi:star',
  MDI_SPEEDOMETER_MEDIUM = 'mdi:speedometer-medium',
  MDI_SPEEDOMETER_SLOW = 'mdi:speedometer-slow',
  MDI_STOPWATCH_OUTLINE = 'mdi:stopwatch-outline',
  MDI_TIMER_SAND_EMPTY = 'mdi:timer-sand-empty',
  MDI_TRANSLATE = 'mdi:translate',
  MDI_TSUNAMI = 'mdi:tsunami',
  MDI_UNDO_VARIANT = 'mdi:undo-variant',
  MDI_USERS = 'mdi:users',
  MINGCUTE_EXTERNAL_LINK_LINE = 'mingcute:external-link-line',
  MINGCUTE_LOADING_FILL = 'mingcute:loading-fill',
  OCTICON_CHECKLIST_16 = 'octicon:checklist-16',
  OFFICE_BUILDING_OUTLINE = 'mdi:office-building-outline',
  OFFICE_BUILDING_PLUS_OUTLINE = 'mdi:office-building-plus-outline',
  OPEN_IN_NEW = 'mdi:open-in-new',
  ORIENTATION = 'mdi:compass-outline',
  PDF_EXPORT = 'mdi:tray-arrow-down',
  PENCIL = 'mdi:pencil-outline',
  PENCIL_BOX = 'mdi:pencil-box',
  PH_DOT_OUTLINE_FILL = 'ph:dot-outline-fill',
  PH_FOLDER = 'ph:folder',
  PH_NOTE_PENCIL_FILL = 'ph:note-pencil-fill',
  PH_WALL_LIGHT = 'ph:wall-light',
  PH_X = 'ph:x',
  PLUS = 'mdi:plus',
  PORTFOLIO = 'mdi:briefcase-outline',
  RECOMMENDED_ACTIONS = 'mdi:creation-outline',
  REMOVE = 'ic:outline-cancel',
  RESIDENTIAL_BUILDING = 'mdi:home-outline',
  RESTORE = 'mdi:restore',
  SEARCH = 'mdi:magnify',
  SORT_UNSORTED = 'mdi:unfold-more-horizontal',
  TRASH = 'mdi:trash-can-outline',
  UIL_LAYERS = 'uil:layers',
  U_VALUE = 'mdi:alpha-u-box',
  VAADIN_LINE_H = 'vaadin:line-h',
  VOLUME = 'mdi:delete-variant',
  WARNING = 'mdi:warning',
  WATER = 'mdi:drop-outline',
  WI_EARTHQUAKE = 'wi:earthquake',
  WPF_SNOW = 'wpf:snow',
  ZONDICONS_EXCLAMATION_SOLID = 'zondicons:exclamation-solid',
  ZONDICONS_INFORMATION_OUTLINE = 'zondicons:information-outline',
  PAUSE_CIRCLE_OUTLINE = 'mdi:pause-circle-outline',
  PLAY_CIRCLE_OUTLINE = 'mdi:play-circle-outline',
  ARCHIVE = 'mdi:archive-outline',
  UNARCHIVE = 'mdi:archive-arrow-up-outline',
  ZIP = 'mdi:folder-zip-outline',
}

export enum STATUS_QUO_TAB_ICONS {
  DEMAND = ICONS.CALCULATOR,
  CONSUMPTION = 'mdi:gauge',
  CLIMATE_RISKS = ICONS.MDI_TSUNAMI,
}

export enum FIELD_ICON_STATES {
  AUTO_CALCULATED = ICONS.CALCULATOR,
  DELETED = 'mdi:trash-can-outline',
  MANUAL_EDIT = 'mdi:pencil-box',
  APPROXIMATED = 'mdi:chart-timeline-variant-shimmer',
}

export enum FILE_FORMAT_ICONS {
  FILE = 'fa-solid:file',
  PDF = 'fa-solid:file-pdf',
  DOC = 'fa-solid:file-word',
  XLS = 'fa-solid:file-excel',
  PPT = 'fa-solid:file-powerpoint',
  IMG = 'fa-solid:file-image',
  CSV = 'fa-solid:file-csv',
  MP3 = 'fa-solid:file-audio',
}

export enum BUILDING_CREATION_ICONS {
  MAP_MARKER = 'mdi:map-marker',
}

export enum CLIMATE_RISK_ICONS {
  TEMPERATURE = 'mdi:day-temperature',
  WIND = 'mdi:weather-windy',
  WATER = 'mdi:water',
  LANDSLIDE = 'mdi:landslide',
}

export enum LABEL_STATUS_ICONS {
  PLANNED = ICONS.CHECK_CIRCLE,
  FAILED = ICONS.CLOSE_CIRCLE,
  PENDING = ICONS.CLOCK,
}

export enum BULK_ACTION_ICONS {
  HOUSE_CITY = 'mdi:house-city-outline',
  FILE_TREE = 'mdi:file-tree-outline',
}

export enum RECALCULATE_ACTION_PLAN_STATUS {
  RECALCULATED = ICONS.CHECK_CIRCLE,
  DELETED = ICONS.CLOSE_CIRCLE,
}

export enum NAVIGATION_ICONS {
  DATA_COLLECTION = ICONS.DATABASE_OUTLINE,
  BUILDING_ANALYSIS = ICONS.BUILDING,
  PORTFOLIO_ANALYSIS = ICONS.PORTFOLIO,
  ACTION_PLANNING = ICONS.CHART_TIMELINE,
  ENERGY_SUPPLIERS = ICONS.DATABASE_OUTLINE,
  ECONOMIC_UNITS = ICONS.ACCOUNT_CIRCLE_OUTLINE,
  REPORTING = ICONS.OCTICON_CHECKLIST_16, //TODO: Replace with MDI icon
  ORG_SETTINGS = ICONS.COG,
  PORTFOLIO_MANAGEMENT = ICONS.PORTFOLIO,
  USERS = ICONS.ACCOUNT_OUTLINE,
  STATUS_QUO_ANALYSIS = ICONS.CHART_BAR,
  ASSOCIATED_ACTION_PLANS = ICONS.CHART_TIMELINE,
  CONSUMPTION_INVOICES = ICONS.DATABASE_OUTLINE,
}

export enum TYPE_OF_USE_CATEGORY_ICONS {
  ACCOUNT_GROUP = 'mdi:bed-outline',
  BED = 'mdi:account-group-outline',
  DESK = 'mdi:desk',
  FACTORY = 'mdi:factory',
  FLASH = 'mdi:flash-outline',
  FOOTBALL = 'mdi:soccer',
  HOME_CITY = ICONS.BUILDING,
  HOSPITAL_BOX = 'mdi:hospital-box-outline',
  MICROSCOPE = 'mdi:microscope',
  SHOPPING = 'mdi:shopping-outline',
  THEATRE = 'mdi:theatre',
  TRANSPORTATION = 'mdi:transportation',
}

export enum PDF_VIEWER_CONTROLS_ICONS {
  ZOOM_OUT = 'mdi:zoom-out-outline',
  ZOOM_IN = 'mdi:zoom-in-outline',
  FIT_SCREEN = 'mdi:fit-to-screen-outline',
}

export enum CBI_ICONS {
  ALPHAPROMPT_LOGS = 'mdi:file-code-outline',
  DUPLICATE = 'mdi:content-duplicate',
  HISTORY = 'mdi:clipboard-text-history-outline',
  REFRESH = 'mdi:refresh',
  ORIGINAL = 'mdi:check-decagram-outline',
}
